import hexToRgba from './hexToRgba';

const getTabCategoryBgColor = questionBackgroundColor => {
  const {r, g, b} = hexToRgba(questionBackgroundColor);
  return [`rgba(${r}, ${g}, ${b}, 0.08)`, `rgba(${r}, ${g}, ${b}, 0.1)`];
};

export default getTabCategoryBgColor;
